<template>
	<div style="padding: 0px;">
		<el-row>
			<el-col :span="10">
				<el-form :inline="false" :model="cabinet" :rules="rules" ref="cabrule" label-width="120px" class="" style="padding-right: 20px;">
					<el-form-item label="外卖柜类型" prop="type">
					    <el-select style="width: 100%;" v-model="cabinet.type" placeholder="请选择外卖柜类型">
							<el-option v-for="item in category" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					    </el-select>
					</el-form-item>
					<el-form-item label="所在区域" prop="area">
					    <el-input clearable v-model="cabinet.area"></el-input>
					</el-form-item>
					<el-form-item label="详细地址" prop="address">
					    <el-input clearable v-model="cabinet.address"></el-input>
					</el-form-item>
					<el-form-item label="状态" prop="state">
					    <el-select style="width: 100%;" v-model="cabinet.state" placeholder="请选择外卖柜状态">
							<el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					    </el-select>
					</el-form-item>
					<el-form-item label="工作时间" prop="worktime">
					    <el-input clearable v-model="cabinet.worktime"></el-input>
					</el-form-item>
					<el-form-item v-show="cabinet.type == 'self'" label="自有柜编码" prop="cabcode">
					    <el-input clearable v-model="cabinet.cabcode"></el-input>
					</el-form-item>
					<el-form-item v-show="cabinet.type == 'self'" label="自有柜号布局" prop="cablayout">
					    <el-input type="textarea" :rows="4" clearable v-model="cabinet.cablayout"></el-input>
					</el-form-item>
				</el-form>
				<div style="text-align: center;">
					<el-button type="primary" @click="saveCabs">保存</el-button>
				</div>
			</el-col>
			<el-col :span="14">
				<div v-if="cabinet.type == 'self' && cabinet.id !='' " style="text-align: center;margin-bottom: 10px;font-weight: 800;">
					柜号详情
					<el-button-group style="float: right;">
						<el-button size="mini" type="primary" icon="el-icon-plus" @click="addUnit()">添加</el-button>
						<el-button size="mini" type="primary" icon="el-icon-refresh" @click="initUnits()">刷新</el-button>
					</el-button-group>
					<!-- <el-button style="float: right;" size="mini" type="primary" icon="el-icon-plus" @click="addUnit()">添加</el-button> -->
				</div>
				<div v-if="cabinet.type == 'self' && cabinet.id !='' " style="border: 1px silver solid;border-radius: 20px; padding: 10px;">
					<div v-for="(cols,index) in cabinet.cablayoutjson.list" :key="index+cols.col" style="margin-top: 10px;">
						<div v-for="cabs in cols.cabs" :key="cabs.addr">
							<div v-if="cabs.haveunit == 1"  :style="{width: '50px',height:'38px',borderRadius:'4px',textAlign:'center',float:'left',
									marginLeft: cabs.marginleft > 10 ? '58px' : '4px',
									backgroundColor: cabs.bgcolor}">
								<el-dropdown style="height: 38px;width: 50px;" @command="handleCommand">
									<span class="el-dropdown-link" style="font-size: 16px;color: white;line-height: 38px;">
										{{ cabs.cabnum }}号
									</span>
									<el-dropdown-menu slot="dropdown" >
										<el-dropdown-item style="color: #E6A23C;" icon="el-icon-box" :command="openCabUnit(cabs.unitid,cabs.cabnum)">开柜</el-dropdown-item>
										<el-dropdown-item icon="el-icon-connection" :command="cabUnitDetail(cabs.unitid,cabs.cabnum)">详情</el-dropdown-item>
										<el-dropdown-item style="color: red;" icon="el-icon-delete" :command="deleteCabUnit(cabs.unitid,cabs.cabnum)">删除</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
						<div style="clear: both;"></div>
					</div>
					
				</div>
				<div v-if="cabinet.type == 'self' && cabinet.id !='' " style="text-align: center;margin-top: 20px;font-weight: 800;">
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #E6A23C;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号可用、有存餐、柜门打开</span>
						<div style="clear: both;"></div>
					</div>
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #67C23A;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号可用、有存餐、柜门关闭</span>
						<div style="clear: both;"></div>
					</div>
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #2979ff;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号可用、无存餐、柜门打开</span>
						<div style="clear: both;"></div>
					</div>
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #909399;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号可用、无存餐、柜门关闭</span>
						<div style="clear: both;"></div>
					</div>
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #fa3534;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号不可用、有存餐、柜门打开</span>
						<div style="clear: both;"></div>
					</div>
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #a9e08f;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号不可用、有存餐、柜门关闭</span>
						<div style="clear: both;"></div>
					</div>
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #fab6b6;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号不可用、无存餐、柜门打开</span>
						<div style="clear: both;"></div>
					</div>
					<div style="width: 50%;float: left;">
						<div style="width: 50px;height: 30px;float: left;background-color: #4a3aa3;"></div>
						<span style="line-height: 30px;margin-left: 10px;float: left;font-weight: 400;">表示：柜号不可用、无存餐、柜门关闭</span>
						<div style="clear: both;"></div>
					</div>
					
					<div style="clear: both;"></div>
				</div>
				
			</el-col>
		</el-row>
		
		<el-dialog @close="initUnits" :modal="true" :modal-append-to-body="false" :append-to-body="true" :destroy-on-close="false" :title="unitTitle" width="60%" :visible.sync="cabinetunitShow">
			<el-form :inline="false" :model="selectedunit" :rules="unitrules" ref="cabunitrule" label-width="120px" class="" style="padding-right: 20px;">
				<el-form-item label="柜号" prop="num">
				    <el-input clearable v-model="selectedunit.num"></el-input>
				</el-form-item>
				<el-form-item label="板地址" prop="addr">
				    <el-input clearable v-model="selectedunit.addr"></el-input>
				</el-form-item>
				<el-form-item label="锁地址" prop="code">
				    <el-input clearable v-model="selectedunit.code"></el-input>
				</el-form-item>
				<el-form-item label="状态" prop="state">
				    <el-select style="width: 100%;" v-model="selectedunit.state" placeholder="请选择状态">
						<el-option v-for="item in unitstateList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="是否有存餐" prop="havefood">
				    <el-select style="width: 100%;" v-model="selectedunit.havefood" placeholder="请选择是否有存餐">
						<el-option v-for="item in foodList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="可用状态" prop="usedstate">
				    <el-select style="width: 100%;" v-model="selectedunit.usedstate" placeholder="请选择可用状态">
						<el-option v-for="item in usedList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="异常描述" prop="notes">
				    <el-input type="textarea" :rows="3" clearable v-model="selectedunit.notes"></el-input>
				</el-form-item>
			</el-form>
			<div style="text-align: center;">
				<el-button type="primary" @click="saveCabUnits">保存</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	//import { nfsprefix, baseUrl } from '/static/baseUrl.js'
	import { editCabinet,addCabinet, queryCabinetUnits,addCabinetUnit,
		editCabinetUnit,deleteCabinetUnit,openCabinetUnit} from '/static/apiUrl.js'
	export default {
		name : 'CabinetDetail',
		data() {
			return {
				cabinetunitShow : false,
				unitTitle : '柜号详情',
				selectunitid : '',
				selectedunit : {
					id : '',
					cabinetid : '',
					num : '',
					code : '',
					addr : '',
					state : '',
					havefood : '',
					usedstate : '',
					notes : ''
				},
				cabinet :{
					id: "",
					type : "",
					area: "",
					address : "" ,
					longitude : 0,
					latitude : 0,
					state : "",
					worktime : "",
					cabcode : "",
					cablayoutjson : null,//{"total":61,"cabwidth":85,"cabheight":60,"list":[{"col":1,"top":100,"left":40,"cabs":[{"cabnum":"01","addr":"01-01","marginleft":4},{"cabnum":"02","addr":"01-02","marginleft":4},{"cabnum":"03","addr":"01-03","marginleft":4},{"cabnum":"04","addr":"01-04","marginleft":4},{"cabnum":"05","addr":"01-05","marginleft":4},{"cabnum":"06","addr":"01-06","marginleft":4},{"cabnum":"07","addr":"01-07","marginleft":4},{"cabnum":"08","addr":"01-08","marginleft":4},{"cabnum":"09","addr":"01-09","marginleft":4},{"cabnum":"10","addr":"01-10","marginleft":4}]},{"col":2,"top":165,"left":40,"cabs":[{"cabnum":"11","addr":"01-11","marginleft":4},{"cabnum":"12","addr":"01-12","marginleft":4},{"cabnum":"13","addr":"01-13","marginleft":4},{"cabnum":"14","addr":"01-14","marginleft":4},{"cabnum":"15","addr":"01-15","marginleft":4},{"cabnum":"16","addr":"01-16","marginleft":4},{"cabnum":"17","addr":"01-17","marginleft":4},{"cabnum":"18","addr":"01-18","marginleft":4},{"cabnum":"19","addr":"01-19","marginleft":4},{"cabnum":"20","addr":"01-20","marginleft":4}]},{"col":2,"top":230,"left":40,"cabs":[{"cabnum":"21","addr":"01-21","marginleft":4},{"cabnum":"22","addr":"01-22","marginleft":4},{"cabnum":"23","addr":"01-23","marginleft":4},{"cabnum":"24","addr":"01-24","marginleft":4},{"cabnum":"25","addr":"01-25","marginleft":4}]}]},
					cablayout: '',//"{\"total\":61,\"cabwidth\":85,\"cabheight\":60,\"list\":[{\"col\":1,\"top\":100,\"left\":40,\"cabs\":[{\"cabnum\":\"01\",\"addr\":\"01-01\",\"marginleft\":4},{\"cabnum\":\"02\",\"addr\":\"01-02\",\"marginleft\":4},{\"cabnum\":\"03\",\"addr\":\"01-03\",\"marginleft\":4},{\"cabnum\":\"04\",\"addr\":\"01-04\",\"marginleft\":4},{\"cabnum\":\"05\",\"addr\":\"01-05\",\"marginleft\":4},{\"cabnum\":\"06\",\"addr\":\"01-06\",\"marginleft\":4},{\"cabnum\":\"07\",\"addr\":\"01-07\",\"marginleft\":4},{\"cabnum\":\"08\",\"addr\":\"01-08\",\"marginleft\":4},{\"cabnum\":\"09\",\"addr\":\"01-09\",\"marginleft\":4},{\"cabnum\":\"10\",\"addr\":\"01-10\",\"marginleft\":4}]},{\"col\":2,\"top\":165,\"left\":40,\"cabs\":[{\"cabnum\":\"11\",\"addr\":\"01-11\",\"marginleft\":4},{\"cabnum\":\"12\",\"addr\":\"01-12\",\"marginleft\":4},{\"cabnum\":\"13\",\"addr\":\"01-13\",\"marginleft\":4},{\"cabnum\":\"14\",\"addr\":\"01-14\",\"marginleft\":4},{\"cabnum\":\"15\",\"addr\":\"01-15\",\"marginleft\":4},{\"cabnum\":\"16\",\"addr\":\"01-16\",\"marginleft\":4},{\"cabnum\":\"17\",\"addr\":\"01-17\",\"marginleft\":4},{\"cabnum\":\"18\",\"addr\":\"01-18\",\"marginleft\":4},{\"cabnum\":\"19\",\"addr\":\"01-19\",\"marginleft\":4},{\"cabnum\":\"20\",\"addr\":\"01-20\",\"marginleft\":4}]},{\"col\":2,\"top\":230,\"left\":40,\"cabs\":[{\"cabnum\":\"21\",\"addr\":\"01-21\",\"marginleft\":4},{\"cabnum\":\"22\",\"addr\":\"01-22\",\"marginleft\":4},{\"cabnum\":\"23\",\"addr\":\"01-23\",\"marginleft\":4},{\"cabnum\":\"24\",\"addr\":\"01-24\",\"marginleft\":4},{\"cabnum\":\"25\",\"addr\":\"01-25\",\"marginleft\":4}]}]}"
				},
				category : [
					{
						value: "mt",
						label: "美团"
					},
					{
						value: "self",
						label: "自有"
					},
					{
						value: "el",
						label: "饿了么"
					}
				],
				stateList : [
					{
						value: "normal",
						label: "启用"
					},
					{
						value: "stop",
						label: "停用"
					}
				],
				unitstateList : [
					{
						value: "open",
						label: "柜门打开"
					},
					{
						value: "lock",
						label: "柜门关闭"
					}
				],
				foodList : [
					{
						value: "y",
						label: "有存餐"
					},
					{
						value: "n",
						label: "无存餐"
					}
				],
				usedList : [
					{
						value: "y",
						label: "可用"
					},
					{
						value: "n",
						label: "异常不可用"
					}
				],
				cabunits : [],
				rules:{
					type: [
						{ required: true, message: '请选择外卖柜类型', trigger: 'blur' }
					],
					area :[
						{ required: true, message: '请输入所在区域', trigger: 'blur' }
					],
					address :[
						{ required: true, message: '请输入外卖柜地址', trigger: 'blur' }
					],
					state :[
						{ required: true, message: '请选择状态', trigger: 'blur' }
					],
					worktime :[
						{ required: true, message: '请输入工作时间', trigger: 'blur' }
					],
				},
				unitrules:{
					num: [
						{ required: true, message: '请输入柜号', trigger: 'blur' }
					],
					code :[
						{ required: true, message: '请输入锁地址', trigger: 'blur' }
					],
					addr :[
						{ required: true, message: '请输入板地址', trigger: 'blur' }
					]
				},
				
			}
		},
		components: {
			
		},
		props:{
			cabinfo : {
				type : Object,
				required : false
			}
		},
		watch:{
			cabinfo : {
				immediate: true,
				handler(newVal) {
					if(newVal == null){
						this.cabinet.id = ''
						this.cabinet.type = ""
						this.cabinet.area= ""
						this.cabinet.address = "" 
						this.cabinet.longitude = 0
						this.cabinet.latitude = 0
						this.cabinet.state = ""
						this.cabinet.worktime = ""
						this.cabinet.cabcode = ""
						this.cabinet.cablayoutjson = null //{"total":61,"cabwidth":85,"cabheight":60,"list":[{"col":1,"top":100,"left":40,"cabs":[{"cabnum":"01","addr":"01-01","marginleft":4},{"cabnum":"02","addr":"01-02","marginleft":4},{"cabnum":"03","addr":"01-03","marginleft":4},{"cabnum":"04","addr":"01-04","marginleft":4},{"cabnum":"05","addr":"01-05","marginleft":4},{"cabnum":"06","addr":"01-06","marginleft":4},{"cabnum":"07","addr":"01-07","marginleft":4},{"cabnum":"08","addr":"01-08","marginleft":4},{"cabnum":"09","addr":"01-09","marginleft":4},{"cabnum":"10","addr":"01-10","marginleft":4}]},{"col":2,"top":165,"left":40,"cabs":[{"cabnum":"11","addr":"01-11","marginleft":4},{"cabnum":"12","addr":"01-12","marginleft":4},{"cabnum":"13","addr":"01-13","marginleft":4},{"cabnum":"14","addr":"01-14","marginleft":4},{"cabnum":"15","addr":"01-15","marginleft":4},{"cabnum":"16","addr":"01-16","marginleft":4},{"cabnum":"17","addr":"01-17","marginleft":4},{"cabnum":"18","addr":"01-18","marginleft":4},{"cabnum":"19","addr":"01-19","marginleft":4},{"cabnum":"20","addr":"01-20","marginleft":4}]},{"col":2,"top":230,"left":40,"cabs":[{"cabnum":"21","addr":"01-21","marginleft":4},{"cabnum":"22","addr":"01-22","marginleft":4},{"cabnum":"23","addr":"01-23","marginleft":4},{"cabnum":"24","addr":"01-24","marginleft":4},{"cabnum":"25","addr":"01-25","marginleft":4}]}]},
						this.cabinet.cablayout = '' 
					}else{
						this.cabinet = newVal
						if(newVal.cablayout != null && newVal.cablayout != ''){
							this.cabinet.cablayoutjson = JSON.parse(newVal.cablayout)
						}
						this.$forceUpdate()
						this.initUnits()
					}
					//this.clearData()
					//this.foodDetail(newVal)
				}
			}
		},
		methods:{
			saveCabs(){
				if(this.cabinet.id == null ||this.cabinet.id == '' ){ //添加
					addCabinet(this.cabinet).then(res => {
						if(0 == res.code){
							this.$message({
								type: 'success',
								message: '添加成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}else{ //编辑
					this.$confirm('确定保存修改?', '保存修改', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						editCabinet(this.cabinet).then(res => {
							if(0 == res.code){
								this.$message({
									type: 'success',
									message: '编辑成功!'
								});
							}else{
								this.$message({
									type: 'error',
									message: res.msg
								});
							}
						})
					}).catch((err) => {
						console.log(err)
					});
				}
			},
			saveCabUnits(){
				this.selectedunit.cabinetid = this.cabinet.id
				if(this.selectedunit.id == null ||this.selectedunit.id == '' ){ //添加
					addCabinetUnit(this.selectedunit).then(res => {
						if(0 == res.code){
							this.$message({
								type: 'success',
								message: '添加柜号成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
						this.cabinetunitShow = false
					})
				}else{ //编辑
					this.$confirm('确定保存柜号信息修改?', '保存修改', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						editCabinetUnit(this.selectedunit).then(res => {
							if(0 == res.code){
								this.$message({
									type: 'success',
									message: '编辑柜号成功!'
								});
							}else{
								this.$message({
									type: 'error',
									message: res.msg
								});
							}
							this.cabinetunitShow = false
						})
					}).catch((err) => {
						console.log(err)
					});
				}
			},
			initUnits(){
				this.cabunits = []
				if(this.cabinet.type != 'self'){
					return 
				}
				queryCabinetUnits({id: this.cabinet.id}).then(res => {
					if(0 == res.code){
						console.log(res.data)
						if(res.data.data.length > 0){
							res.data.data.forEach((unit) => {
								this.cabunits.push({
									id : unit.cabinetunit_id,
									cabinetid : unit.cabinetunit_cabinetid,
									num : unit.cabinetunit_num,
									code: unit.cabinetunit_code,
									state : unit.cabinetunit_state,
									havefood : unit.cabinetunit_havefood,
									usedstate : unit.cabinetunit_usedstate,
									addr: unit.cabinetunit_addr, //板地址
									note: unit.cabinetunit_notes,
									bgcolor : this.getcabunitColor(unit.cabinetunit_havefood,unit.cabinetunit_usedstate,unit.cabinetunit_state),
								})
							})
							//
							if(this.cabinet.cablayoutjson != null && this.cabinet.cablayoutjson.list != null && 
								this.cabinet.cablayoutjson.list.length > 0 ){
								this.cabinet.cablayoutjson.list.forEach((cols ) => {
									if(cols.cabs != null && cols.cabs.length > 0){
										cols.cabs.forEach((cab) => {
											let haveunit = false
											let bgcolor = ''
											let unitid = ''
											/* let marginleft = '4px'
											if(cab.marginleft > 10){
												marginleft = '54px'
											} */
											if(this.cabunits.length > 0){
												this.cabunits.forEach((myunit) =>{
													if(cab.addr == (myunit.addr+'-'+myunit.code)){
														haveunit = true
														bgcolor = myunit.bgcolor
														unitid = myunit.id
														return false
													}
												})
											}
											cab.haveunit = haveunit ? 1 : 0
											cab.bgcolor = haveunit ? bgcolor : '#c4c6c9'
											cab.unitid = haveunit ? unitid : ''
											//cab.marginleft = marginleft
										})
									}
								})
								this.$forceUpdate()
							}
							
						}else{
							this.$message({
								type: 'warning',
								message: "外卖柜没有柜号"
							});
						}
						 
					}else{
						this.$message({
							type: 'error',
							message: res.msg
						});
					}
				})
			},
			getcabunitColor(food,used,st){
				if('y' == used){
					//'#909399'
					if('y' == food){
						if('open' == st){
							return '#E6A23C'
						}else{
							return '#67C23A'
						}
					}else{
						if('open' == st){
							return '#2979ff'
						}else{
							return '#909399'
						}
					}
				}else{
					if('y' == food){
						if('open' == st){
							return '#fa3534'
						}else{
							return '#a9e08f'
						}
					}else{
						if('open' == st){
							return '#fab6b6'
						}else{
							return '#4a3aa3'
						}
					}
				}
			},
			openCabUnit(uid,name){
				console.log(uid,name)
				return {
				    'command': 'open',
				    'uid': uid,
				    'name' : name,
				}
			},
			cabUnitDetail(uid,name){
				console.log(uid,name)
				return {
				    'command': 'detail',
				    'uid': uid,
				    'name' : name,
				}
			},
			deleteCabUnit(uid,name){
				console.log(uid,name)
				return {
				    'command': 'delete',
				    'uid': uid,
					'name' : name,
				}
			},
			addUnit(){
				this.unitTitle = "添加柜号"
				this.cabinetunitShow = true
				this.selectedunit.id = ''
				this.selectedunit.cabinetid = ''
				this.selectedunit.num = ''
				this.selectedunit.code = ''
				this.selectedunit.addr = ''
				this.selectedunit.state = ''
				this.selectedunit.havefood = ''
				this.selectedunit.usedstate = ''
				this.selectedunit.notes = ''
			},
			handleCommand(val){
				console.log(val)
				let uid = val.uid
				let name = val.name 
				switch ( val.command){
					case 'open' : {
						this.$confirm('确定打开柜号'+ name +'吗?请慎重！', '人工开柜', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							openCabinetUnit({id : uid}).then(res => {
								if(0 == res.code){
									this.initUnits()
									this.$message({
										type: 'success',
										message: name +"号柜，已成功打开"
									});
								}else{
									this.$message({
										type: 'error',
										message: res.msg
									});
								}
							})
						}).catch((err) => {
							console.log(err)
						});
					}
					break
					case 'delete' : {
						this.$confirm('确定删除柜号'+name+'?', '删除柜号', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							//addCabinetUnit,editCabinetUnit,
							let fids = [uid]
							deleteCabinetUnit({
								ids : fids
							}).then(res => {
								console.log(res)
								if(0 == res.code){
									this.initUnits()
									this.$message({
										type: 'success',
										message: '删除成功!'
									});
								}else{
									this.$message({
										type: 'error',
										message: res.msg
									});
								}
							})
						}).catch((err) => {
							console.log(err)
						});
					}
					break
					case 'detail': {
						this.unitTitle = "修改"+name+"号柜信息"
						this.cabunits.forEach((unit) => {
							if(uid == unit.id){
								this.selectedunit = unit
							}
						})
						this.cabinetunitShow = true
					}
					break
				}
			}
		},
	}
</script>

<style>
</style>